"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigestEmailSectionSchema = exports.DeliveryCadenceSchema = void 0;
const v4_1 = require("zod/v4");
exports.DeliveryCadenceSchema = v4_1.z.enum(['multiWeekly', 'weekly', 'daily']);
exports.DigestEmailSectionSchema = v4_1.z.enum([
    'borrowingBaseSummary',
    'concentrationLimit',
    'ineligibleReceivables',
    'cashBalance',
    'deliverables',
]);
//# sourceMappingURL=Email.js.map